"use strict";

define('rs/authenticate/authenticate.view',['vertebrae', 'rs/helper', 'spin', 'jqueryplaceholder'], function (Vertebrae, helper, Spinner) {
  var AuthenticateView = Vertebrae.View.extend({
    events: {
      'click .login': 'handleLogin',
      'enterkey input': 'handleLogin',
      'click .forgot-submit': 'handleForgotSubmitClick',
      'click .forgot-link.username': 'handleForgotUsernameClick',
      'click .forgot-link.password': 'handleForgotPasswordClick',
      'click .popover': 'handlePopoverEvents',
      'enterkey input.resetpw-inputs': 'handleResetPassword',
      'click .fpv-save': 'handleResetPassword',
      'enterkey input.remember-me-input': 'handleToggleRememberMe',
      'enterkey .login': 'handleLogin',
      'click .error-close': 'handleCloseError',
      'click .editable-field': 'handleEditableFieldClick',
      'blur .editable-input': 'handleEditableInputChange',
      'change .preset-user-select': 'handleLogin'
    },
    handleCloseError: function handleCloseError(ev) {
      $(ev.currentTarget).closest('.input-error').slideUp();
    },
    handleEditableFieldClick: function handleEditableFieldClick(ev) {
      var input = $(ev.currentTarget).siblings('.editable-input');
      $(ev.currentTarget).hide();
      input.css('display', 'inline-block').find('input').focus();
    },
    handleEditableInputChange: function handleEditableInputChange(ev) {
      var el = $(ev.currentTarget),
        val = el.find('input').val();
      if (!val.length) {
        val = 'dummy.host';
        el.find('input').val(val);
      }
      el.hide().siblings('.editable-field').show().find('.btn.btn-link').text(val);
    },
    spinner: {
      lines: 11,
      length: 4,
      width: 2,
      radius: 8,
      corners: 1,
      rotate: 0,
      direction: 1,
      color: '#333',
      speed: 0.9,
      trail: 60,
      shadow: false,
      hwaccel: false,
      className: 'spinner login-spinner',
      zIndex: 2e9,
      top: 68
    },
    templates: {
      'authenticate.init': 'renderInitFragment',
      'authenticate.fpv': 'renderFpvFragment',
      'authenticate.forgot': 'renderForgotFragment'
    },
    handleLogin: function handleLogin(ev) {
      this.hideLoginError();
      this.getDelegate().requestLogin();
    },
    handleToggleRememberMe: function handleToggleRememberMe(ev) {
      var checkbox = $(ev.currentTarget),
        val = checkbox.prop('checked');
      checkbox.prop('checked', !val);
    },
    showPasswordResetError: function showPasswordResetError(message) {
      this.$(".reset-error").slideDown();
    },
    handleResetPassword: function handleResetPassword() {
      this.getDelegate().requestPasswordReset($(".password-input").val(), $(".repassword-input").val());
    },
    handlePopoverEvents: function handlePopoverEvents(ev) {
      ev.stopPropagation();
    },
    handleForgotSubmitClick: function handleForgotSubmitClick(ev) {
      var $ev = $(ev.currentTarget),
        container = $ev.parent().parent().parent(),
        isPwd = container.hasClass("password");
      if (isPwd) {
        this.getDelegate().requestForgotPassword(container.find('.email-entry').val(), container.find('.username-entry').val());
      } else {
        this.getDelegate().requestForgotUsername(container.find('.email-entry').val());
      }
    },
    showPopover: function showPopover(element, params) {
      var that = this;
      this.hidePopover();
      element.popover({
        animation: true,
        html: true,
        placement: 'bottom',
        trigger: 'manual',
        content: this.renderForgotFragment(params)
      });
      this._currentPopover = element;
      element.popover('show');
      $('.forgot-inputs').placeholder();
      _.defer(function () {
        $(document).one('click.popover', function (ev) {
          that.hidePopover();
        });
      });
    },
    popoverConfirmation: function popoverConfirmation() {
      this._currentPopover.next().find(".form").slideUp();
      this._currentPopover.next().find(".response").slideDown();
    },
    popoverError: function popoverError() {
      this.showForgotEmailInputError("The provided information is not valid.");
    },
    hidePopover: function hidePopover() {
      if (this._currentPopover) {
        $(document).off('click.popover');
        this._currentPopover.popover('destroy');
      }
    },
    handleForgotUsernameClick: function handleForgotUsernameClick(ev) {
      var link = $('.forgot-link.username');
      ev.originalEvent.signalElement = link.get(0);
      this.showPopover(link, {});
    },
    handleForgotPasswordClick: function handleForgotPasswordClick(ev) {
      var link = $('.forgot-link.password');
      ev.originalEvent.signalElement = link.get(0);
      this.showPopover(link, {
        forgotPassword: true
      });
    },
    showLoginError: function showLoginError(mesg) {
      this.$('.login-error .error-message').text(mesg);
      this.$('.login-error').slideDown();
      this._hideLoginErrorTimeout = setTimeout(this.hideLoginError.proxy(this), 5000);
    },
    hideLoginError: function hideLoginError() {
      clearTimeout(this._hideLoginErrorTimeout);
      this.$('.login-error').slideUp();
    },
    showUsernameError: function showUsernameError(mesg) {
      this.$('.username-error .error-message').text(mesg);
      this.$('.username-error').slideDown();
    },
    showPasswordError: function showPasswordError(mesg) {
      this.$('.password-error .error-message').text(mesg);
      this.$('.password-error').slideDown();
    },
    showPasswordSuccess: function showPasswordSuccess() {
      this.$('.password-error').slideUp();
    },
    showUsernameSuccess: function showUsernameSuccess() {
      this.$('.username-error').slideUp();
    },
    getResetPassword: function getResetPassword() {
      return this.$('.reset-password');
    },
    getResetRePassword: function getResetRePassword() {
      return this.$('.reset-repassword');
    },
    getUsername: function getUsername() {
      return this.$('.username-input').val();
    },
    getPassword: function getPassword() {
      return this.$('.password-input').val();
    },
    getPresetUser: function getPresetUser() {
      return this.$('.preset-user-select').val();
    },
    getTenant: function getTenant() {
      return this.$('.tenant-input').val();
    },
    getRememberMe: function getRememberMe() {
      return this.$('.remember-me-input').prop('checked');
    },
    showForgotEmailInputError: function showForgotEmailInputError(mesg) {
      this._currentPopover && this._currentPopover.next().find(".email-input-error .error-message").text(mesg);
      this._currentPopover && this._currentPopover.next().find(".email-input-error").slideDown();
    },
    showForgotEmailInputSuccess: function showForgotEmailInputSuccess() {
      this._currentPopover && this._currentPopover.next().find(".email-input-error").slideUp();
    },
    showForgotUserInputError: function showForgotUserInputError(mesg) {
      this._currentPopover && this._currentPopover.next().find(".user-input-error .error-message").text(mesg);
      this._currentPopover && this._currentPopover.next().find(".user-input-error").slideDown();
    },
    showForgotUserInputSuccess: function showForgotUserInputSuccess() {
      this._currentPopover && this._currentPopover.next().find(".user-input-error").slideUp();
    },
    getForgotEmailInput: function getForgotEmailInput() {
      return $(".email-entry.forgot-inputs").val();
    },
    getForgotUserInput: function getForgotUserInput() {
      return $(".username-entry.forgot-inputs").val();
    },
    showLoading: function showLoading() {
      var that = this,
        target = this.$('.login-stripe').get(0);
      this._spinner = new Spinner(this.spinner).spin(target);
      return function () {
        that.hideLoading();
      };
    },
    hideLoading: function hideLoading() {
      if (this._spinner) {
        this._spinner.stop();
        this._spinner = null;
      }
    },
    render: function render(mode) {
      if (!mode) {
        var templateParams = this.getDelegate().getTemplateProperties();
        this.$el.html(this.renderInitFragment(templateParams));
        if (templateParams.username) {
          this.$('.password-input').focus();
        } else {
          this.$('.username-input').focus();
        }
      } else if (mode == "forgotPasswordVerify") {
        this.$el.html(this.renderFpvFragment());
      }
      $('input').placeholder();
    },
    showForgotMessage: function showForgotMessage(message) {
      $(".field-container").fadeOut(function () {
        var mesCont = $(".message-container");
        mesCont.fadeIn();
        if (message) {
          mesCont.find("span").html(message);
        }
        $(".fpv-save").fadeOut();
      });
    },
    showForgotFields: function showForgotFields() {
      $(".message-container").fadeOut(function () {
        $(".field-container").fadeIn();
        $(".fpv-save").fadeIn();
      });
    },
    changeForgotMessage: function changeForgotMessage(message) {
      $(".message-container").find("span").html(message);
    },
    unload: function unload() {
      clearTimeout(this._hideLoginErrorTimeout);
      this._super.apply(this, arguments);
    }
  });
  return AuthenticateView;
});

